import styled from "styled-components";

const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 1512px;
  padding-left: 25px;
  padding-right: 25px; 
  
  @media only screen and (min-width: 501px) {
    padding-left: 3em;
    padding-right: 3em;
  }
`;

export {
  Container
}
